import React, { useMemo } from 'react'
import EmptyMessage from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/EmptyMessage'
import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'
import KeyValues, { KeyValue } from 'components/KeyValues'
import { Label, Loader } from 'shared/ui'
import { getTimestampDisplayString } from 'util/date'
import { getFormattedPrice } from 'util/numbers'

import LinkedResourceActions from '../LinkedResourceActions'
import ShopifyAddress from './ShopifyAddress'
import ShopifyOrderRow from './ShopifyOrderRow'

export default function ShopifyIndex({
  className,
  data,
  doNavigatableSetState,
  isLoading,
}) {
  const { shop, customer, customerUrl } = data || {}
  const actions = useMemo(
    () => [
      {
        blankTarget: true,
        text: ['View on Shopify'],
        url: customerUrl,
      },
    ],
    [customerUrl]
  )
  if (isLoading) return <Loader />
  if (!shop) return null
  if (!customer)
    return <EmptyMessage>There is no customer information.</EmptyMessage>
  const { orders } = customer
  return (
    <div className={className}>
      <Label>Customer</Label>
      <KeyValues>
        {customer.id && (
          <KeyValue
            title="Customer ID"
            value={
              <a href={customerUrl} target="_blank" rel="noopener noreferrer">
                {customer.id}
              </a>
            }
          />
        )}
        {customer.created_at && (
          <KeyValue
            title="Signed up"
            value={getTimestampDisplayString(customer.created_at)}
          />
        )}
        {(customer.total_spent || customer.total_spent === 0) && (
          <KeyValue
            title="Total spent"
            value={getFormattedPrice(customer.total_spent, shop.currency)}
          />
        )}
        {(customer.orders_count || customer.orders_count === 0) && (
          <KeyValue title="Total orders" value={customer.orders_count} />
        )}
        {customer.default_address && (
          <KeyValue
            title="Primary address"
            value={<ShopifyAddress address={customer.default_address} />}
            singleline={false}
          />
        )}
      </KeyValues>
      <Label>Recent orders</Label>
      <NavigatableIntegrationWidgetCard.List>
        {orders.length === 0 && (
          <EmptyMessage>This customer has no orders yet.</EmptyMessage>
        )}
        {orders.map(order => {
          return (
            <ShopifyOrderRow
              doNavigatableSetState={doNavigatableSetState}
              key={order.id}
              order={order}
              moneyFormat={shop.money_format}
            />
          )
        })}
      </NavigatableIntegrationWidgetCard.List>
      <LinkedResourceActions actions={actions} />
    </div>
  )
}
